export const annualStatusPresentation = {
  CLIENT_REQUESTED_ADJUSTMENT: 'Client Requested Adjustment',
  CLIENT_REVIEWING: 'Client Reviewing',
  COMPLETE: 'Complete',
  DATA_REQUESTED: 'Data Requested',
  NEED_DATA: 'Need Data',
  NOT_READY: 'Not Ready',
  NOT_READY_EXTENSION_FILED: 'Not Ready - Extension Filed',
  NOT_APPLICABLE: 'Not Applicable',
  PEER_REVIEW_REQUESTED: 'Peer Review Requested',
  READY_FOR_WORK: 'Ready For Work',
  REVISION_REQUIRED: 'Revision Required',
};

export const annualStatusOptions = {
  yearEndReview: [
    { label: 'Not Ready', value: 'NOT_READY' },
    { label: 'Not Ready - Extension Filed', value: 'NOT_READY_EXTENSION_FILED' },
    { label: 'Ready For Work', value: 'READY_FOR_WORK' },
    { label: 'Complete', value: 'COMPLETE' },
    { label: 'Not Applicable', value: 'NOT_APPLICABLE' },
    { label: 'Peer Review Requested', value: 'PEER_REVIEW_REQUESTED' },
    { label: 'Revision Required', value: 'REVISION_REQUIRED' },
  ],
  yearEndFinancialPackage: [
    { label: 'Not Ready', value: 'NOT_READY' },
    { label: 'Ready For Work', value: 'READY_FOR_WORK' },
    { label: 'Complete', value: 'COMPLETE' },
    { label: 'Not Applicable', value: 'NOT_APPLICABLE' },
    { label: 'Peer Review Requested', value: 'PEER_REVIEW_REQUESTED' },
    { label: 'Revision Required', value: 'REVISION_REQUIRED' },
    { label: 'Client Reviewing', value: 'CLIENT_REVIEWING' },
    { label: 'Client Requested Adjustment', value: 'CLIENT_REQUESTED_ADJUSTMENT' },
  ],
};
